// removed by extract-text-webpack-plugin
module.exports = {"statisticsCom":"_3mpObGPQVBgl5Vu9_3cR72","top":"_3PzpzmbQG07zdxRkjFcDws","mapContainer":"_38vub2VQJmwtfMgEIQBv38"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Statistics/Statistics.less
// module id = 994
// module chunks = 0